/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getSuggestedActions} from '../api'

 export const useQueryGetSuggestedActions = createReactQueryHook('getSuggestedActions', getSuggestedActions)
